/**
 * Close the cart drawer when the shopper clicks or taps anywhere outside it.
 *
 * In modal mode (< 990px) the theme's native <dialog> backdrop already closes
 * on an outside tap (see ThemeDrawer#onBackdropClick), so this only needs to
 * cover the desktop "squeeze" mode, where the drawer is opened non-modally and
 * the page stays interactive with no backdrop to click.
 *
 * A single capture-phase listener is attached once and checks the drawer's
 * live open state at click time — this avoids any dependency on open/close
 * event timing or on the drawer element surviving re-renders.
 */
(() => {
  const modalQuery = window.matchMedia('(max-width: 989px)');

  document.addEventListener(
    'click',
    (event) => {
      // Modal mode closes via its native backdrop — leave it alone.
      if (modalQuery.matches) return;

      const drawer = document.querySelector('#cart-drawer');
      if (!drawer || !drawer.hasAttribute('open')) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      // Keep the drawer open only for clicks inside it (including its own nested
      // dialogs, e.g. payment terms). We can't guard on "any <dialog>" because
      // the product media gallery is itself a permanently-open <dialog>.
      if (target.closest('#cart-drawer')) return;
      // The cart icon toggles the drawer itself; let it handle its own click.
      if (target.closest('[aria-controls="cart-drawer"]')) return;

      /** @type {any} */ (drawer).close();
    },
    true
  );
})();
